import { render } from "./m-prediction.vue?vue&type=template&id=6e12e17c&scoped=true&ts=true"
import script from "./m-prediction.vue?vue&type=script&lang=ts"
export * from "./m-prediction.vue?vue&type=script&lang=ts"

import "./m-prediction.vue?vue&type=style&index=0&id=6e12e17c&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e12e17c"]])

export default __exports__